import { useSuspenseQuery } from '@tanstack/react-query';
import { createQuotaManagementComponent } from '@/components/QuotaManagement/createQuotaManagementComponent';
import { useRouteContextQuery, useUserOwnAccounts } from '@/routes/_authenticated.hooks';

/**
 * Component to manage quota for the maximum number of owned accounts.
 * It fetches the current number of owned accounts and compares it with the maximum allowed quota.
 */
export const WithMaxOwnedAccountsQuota = createQuotaManagementComponent(() => {
  const value = useUserOwnAccounts().length;
  const {
    data: { maxOwnedAccounts: quota },
  } = useSuspenseQuery(useRouteContextQuery((s) => s.getAuthenticatedUserQuotasQuery));

  return { available: value < quota, value, quota };
});
